import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs, FreeMode, Navigation, EffectFade } from "swiper/modules";
import Image from "../image/Image";
import { getImageLink } from "../../../utils/images";

const ProductImageGallery = ({ product }) => {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    // Swiper logs a console warning when loop is on but slide count is too low
    // for the configured slidesPerView. External products (commercetools/SFCC)
    // often ship just one image, so disable loop unless there's enough.
    const imageCount = (product.image && product.image.length) || 0;
    const mainLoop = imageCount > 1;
    const thumbsSlidesPerView = 4;
    const thumbsLoop = imageCount > thumbsSlidesPerView;

    return (
        <Fragment>
            <div className="product-large-image-wrapper">
                {product.discount || product.new ? (
                    <div className="product-img-badges">
                        {product.discount ? <span className="pink">-{product.discount}%</span> : ""}
                        {product.new ? <span className="purple">New</span> : ""}
                    </div>
                ) : (
                    ""
                )}
                <LightgalleryProvider>
                    <Swiper
                        modules={[Thumbs, EffectFade]}
                        thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                        spaceBetween={10}
                        loop={mainLoop}
                        effect={"fade"}
                        className="swiper-wrapper"
                    >
                        {product.image &&
                            product.image.map((single, key) => {
                                return (
                                    <SwiperSlide key={key}>
                                        <LightgalleryItem group="any" src={getImageLink(single)}>
                                            <button>
                                                <i className="pe-7s-expand1"></i>
                                            </button>
                                        </LightgalleryItem>
                                        <div className="single-image">
                                            <Image imageNode={single} className="img-fluid" />
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                    </Swiper>
                </LightgalleryProvider>
            </div>
            <div className="product-small-image-wrapper mt-15">
                <Swiper
                    onSwiper={setThumbsSwiper}
                    modules={[Thumbs, FreeMode, Navigation]}
                    spaceBetween={10}
                    slidesPerView={thumbsSlidesPerView}
                    touchRatio={0.2}
                    freeMode={true}
                    loop={thumbsLoop}
                    slideToClickedSlide={true}
                    navigation={{
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    }}
                    className="swiper-wrapper"
                >
                    {product.image &&
                        product.image.map((single, key) => {
                            return (
                                <SwiperSlide key={key}>
                                    <div className="single-image">
                                        <Image imageNode={single} className="img-fluid" />
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                </Swiper>
                {/* Custom Navigation Buttons for Thumbnail Swiper */}
                <button className="swiper-button-prev ht-swiper-button-nav">
                    <i className="pe-7s-angle-left" />
                </button>
                <button className="swiper-button-next ht-swiper-button-nav">
                    <i className="pe-7s-angle-right" />
                </button>
            </div>
        </Fragment>
    );
};

ProductImageGallery.propTypes = {
    product: PropTypes.object,
};

export default ProductImageGallery;
